"use client";

import type { HTMLAttributes } from "react";
import { BrandXMark } from "@/components/icons/SiteMarks";

type PillButtonProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
};

/** Pill CTA — brand X marks instead of scroll-spine pipe lines. */
export function PillButton({ label, className, ...props }: PillButtonProps) {
  return (
    <div className={className ? `button f a-c j-c ${className}` : "button f a-c j-c"} {...props}>
      <BrandXMark className="btn_x" />
      <span className="label">{label}</span>
      <BrandXMark className="btn_x" />
    </div>
  );
}
